import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-24-completed",
  "use": "icon-icon-24-completed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon-24-completed\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm5.52-13.621a1 1 0 0 1 0 1.414l-6.777 6.778a1 1 0 0 1-1.415 0l-3.535-3.535a1 1 0 0 1 1.414-1.415l2.616 2.616a.3.3 0 0 0 .424 0l5.86-5.858a1 1 0 0 1 1.414 0z\" fill=\"#29A360\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol